export default __webpack_public_path__ + "images/analisis_bg2.jpg";